module.exports = __webpack_public_path__ + "media/icon/icon-line-green-c62dbad3.svg";